module.exports = __webpack_public_path__ + "static/media/discard.20586d72.svg";